import { createRouter, createWebHistory } from 'vue-router'
import PageSignin from '../pages/PageSignin.vue'
import store from '../store/index.js'

const routes = [
    {
        //ログイン
        path: '/signin',
        name: 'Signin',
        meta: { for_guest: true, title: 'ログイン' },
        component: PageSignin
    },
    {
        //ログイン
        path: '/signup',
        name: 'Signup',
        meta: { for_guest: true, title: '60日間無料トライアル登録' },
        component: () => import('../pages/PageSignup.vue')
    },
    {
        //ダッシュボード
        path: '/',
        name: 'Home',
        meta: { title: 'ダッシュボード' },
        component: () => import('../pages/PageHome.vue')
    },
    {
        //日報一覧
        path: '/report',
        name: 'Report',
        meta: { title: '日報一覧' },
        component: () => import('../pages/PageReport.vue')
    },
    {
        //日報登録
        path: '/report/add',
        name: 'ReportAdd',
        meta: { title: '日報登録' },
        component: () => import('../pages/PageReportAdd.vue')
    },
    {
        //日報編集
        path: '/report/:report/edit',
        name: 'ReportEdit',
        meta: { title: '日報編集' },
        component: () => import('../pages/PageReportEdit.vue')
    },
    {
        // 収支一覧（月別）
        path: '/profit',
        name: 'Profit',
        meta: { title: '収支一覧' },
        component: () => import('../pages/PageProfit.vue')
    },
    {
        // 収支一覧（案件別）
        path: '/profit/project',
        name: 'ProfitProject',
        meta: { title: '収支一覧' },
        component: () => import('../pages/PageProfitProject.vue')
    },
    {
        // 収支詳細/入力
        path: '/profit/:profit',
        name: 'ProfitEdit',
        meta: { title: '収支詳細/入力' },
        component: () => import('../pages/PageProfitEdit.vue')
    },
    {
        // 月別収支集計
        path: '/profit/stats/monthly',
        name: 'ProfitStatsMonthly',
        meta: { title: '月別収支レポート' },
        component: () => import('../pages/PageProfitStatsMonthly.vue')
    },
    {
        // 案件別収支集計
        path: '/profit/stats/project/',
        name: 'ProfitStatsProject',
        meta: { title: '案件別収支レポート' },
        component: () => import('../pages/PageProfitStatsProject.vue')
    },
    {
        // 案件収支詳細
        path: '/profit/stats/project/:project',
        name: 'ProfitStatsProjectDetail',
        meta: { title: '案件サマリー' },
        component: () => import('../pages/PageProfitStatsProjectDetail.vue')
    },
    {
        //稼働集計
        path: '/work',
        name: 'Work',
        meta: { title: '稼働集計' },
        component: () => import('../pages/PageWork.vue')
    },
    {
        //稼働明細
        path: '/work/detail',
        name: 'WorkDetail',
        meta: { title: '稼働明細' },
        component: () => import('../pages/PageWorkDetail.vue')
    },
    {
        //顧客別レポート
        path: '/stats/customer',
        name: 'StatsCustomer',
        meta: { title: '顧客別収支レポート' },
        component: () => import('../pages/PageStatsCustomer.vue')
    },
    {
        //生産性レポート
        path: '/stats/productivity',
        name: 'StatsProductivity',
        meta: { title: '生産性レポート' },
        component: () => import('../pages/PageStatsProductivity.vue')
    },
    {
        //売上粗利推移レポート
        path: '/stats/transition',
        name: 'StatsTransition',
        meta: { title: '売上粗利推移レポート' },
        component: () => import('../pages/PageStatsTransition.vue')
    },
    {
        //案件マスタ
        path: '/master/project/',
        name: 'MasterProject',
        meta: { gate: 'canManageMaster', title: '案件マスタ' },
        component: () => import('../pages/PageMasterProject.vue')
    },
    {
        //案件マスタ登録
        path: '/master/project/add',
        name: 'MasterProjectAdd',
        meta: { gate: 'canManageMaster', title: '案件マスタ' },
        component: () => import('../pages/PageMasterProjectAdd.vue')
    },
    {
        //案件マスタ編集
        path: '/master/project/:project',
        name: 'MasterProjectEdit',
        meta: { gate: 'canManageMaster', title: '案件マスタ' },
        component: () => import('../pages/PageMasterProjectEdit.vue')
    },
    {
        //顧客マスタ
        path: '/master/customer/',
        name: 'MasterCustomer',
        meta: { gate: 'canManageMaster', title: '顧客マスタ' },
        component: () => import('../pages/PageMasterCustomer.vue')
    },
    {
        //外注先マスタ
        path: '/master/category/',
        name: 'MasterCategory',
        meta: { gate: 'canManageMaster', title: '案件分類マスタ' },
        component: () => import('../pages/PageMasterCategory.vue')
    },
    {
        //外注先マスタ
        path: '/master/subcontractor/',
        name: 'MasterSubcontractor',
        meta: { gate: 'canManageMaster', title: '外注先マスタ' },
        component: () => import('../pages/PageMasterSubcontractor.vue')
    },
    {
        //部門マスタ
        path: '/master/department/',
        name: 'MasterDepartment',
        meta: { gate: 'canManageMaster', title: '部門マスタ' },
        component: () => import('../pages/PageMasterDepartment.vue')
    },
    {
        //エクスポート
        path: '/export',
        name: 'Export',
        meta: { gate: 'canExportCsv', title: 'エクスポート履歴' },
        component: () => import('../pages/PageExport.vue')
    },
    {
        //インポート
        path: '/import',
        name: 'Import',
        meta: { gate: 'canImportCsv', title: 'インポート' },
        component: () => import('../pages/PageImport.vue')
    },
    {
        //インポート履歴
        path: '/import/history',
        name: 'ImportHistory',
        meta: { gate: 'canImportCsv', title: 'インポート履歴' },
        component: () => import('../pages/PageImportHistory.vue')
    },
    {
        // ユーザ管理
        path: '/system/user',
        name: 'SystemUser',
        meta: { gate: 'canManageUser', title: 'ユーザ管理' },
        component: () => import('../pages/PageSystemUser.vue')
    },
    {
        // ユーザ追加
        path: '/system/user/add',
        name: 'SystemUserAdd',
        meta: { gate: 'canManageUser', title: 'ユーザ登録' },
        component: () => import('../pages/PageSystemUserAdd.vue')
    },
    {
        // ユーザ管理編集
        path: '/system/user/:user',
        name: 'SystemUserEdit',
        meta: { gate: 'canManageUser', title: 'ユーザ編集' },
        component: () => import('../pages/PageSystemUserEdit.vue')
    },
    {
        // ユーザ標準単価管理
        path: '/system/user/:user/unit',
        name: 'SystemUserLaborCost',
        meta: { gate: 'canManageUser', title: '標準労務単価設定' },
        component: () => import('../pages/PageSystemUserLaborCost.vue')
    },
    {
        // 会社情報
        path: '/system/company',
        name: 'SystemCompany',
        meta: { gate: 'canEditCompany', title: '会社設定' },
        component: () => import('../pages/PageSystemCompany.vue')
    },
    {
        // 支払 一般ユーザでも状況確認ができるよう、gate はつけない
        path: '/system/payment',
        name: 'SystemPayment',
        meta: { title: 'お支払い' },
        component: () => import('../pages/PageSystemPayment.vue')
    },
    {
        // アカウント
        path: '/account',
        name: 'Account',
        meta: { title: 'アカウント' },
        component: () => import('../pages/PageAccount.vue')
    },


    /**
     * エラー系
     */
    {
        //403ページ
        path: '/error/403',
        name: 'Error403',
        meta: { title: '権限エラー' },
        component: () => import('../pages/error/PageError403.vue')
    },
    {
        //404ページ ＝ 上記のいずれにもマッチしないもの
        path: '/:pathMatch(.*)*',
        name: 'Error404',
        meta: { title: 'NOT FOUND' },
        component: () => import('../pages/error/PageError404.vue')
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.for_guest) {
        //ログインの不要な画面
        next();
        return;
    }

    //ログイン切れ
    if (!store.state.auth.access_token) {
        next({ path: '/signin', query: { redirect: to.fullPath } });
        return;
    }

    //仮パスワード
    if (store.state.auth.is_password_temporary && to.name !== 'Account') {
        next({ name: 'Account' });
        return;
    }

    //権限なし
    if (to.meta && to.meta.gate) {
        if (false === store.getters['auth/' + to.meta.gate]()) {
            next({ path: '/error/403' });
            return;
        }
    }

    next();
});

const baseTitle = document.querySelector('title')?.textContent || 'ヒト✕ツキ';

router.afterEach((to) => {
    if (to.meta.title) {
        document.title = `${baseTitle} - ${to.meta.title}`
    } else {
        document.title = baseTitle
    }
})


export default router
